// A single "Name" box has to become the firstName/lastName pair the lead path
// expects. Split on the first run of whitespace so double-barrelled surnames
// ("Jane van der Berg") stay intact as one last name.
//
// A one-word entry yields an empty last name rather than guessing. Forms in
// single-name mode allow that; split-name forms still require both, enforced in
// WebformIntakeService against the form's own config.
export function splitFullName(value: string): { firstName: string; lastName: string } {
    const normalised = value.trim().replace(/\s+/g, ' ')
    const boundary = normalised.indexOf(' ')
    if (boundary === -1) return { firstName: normalised, lastName: '' }
    return {
        firstName: normalised.slice(0, boundary),
        lastName: normalised.slice(boundary + 1),
    }
}
